// extracted by mini-css-extract-plugin
module.exports = {"section":"NumberAni_section__8FBJ1"};